import React from 'react';
import { CircleCheckBigIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
type CtaButtonProps = {
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
  id?: string;
};
export function CtaButton({
  label,
  note,
  tone = 'light',
  id
}: CtaButtonProps) {
  return <div id={id} className="mx-auto w-full max-w-xl" data-id="element-29" data-mp="ck9f3o7axsdd">
      <a href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#166534] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-hover active:translate-y-[3px] active:shadow-[0_3px_0_0_#166534] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-light md:text-xl" data-id="element-30" data-mp="cmvlvlmdc3uj">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-31" data-mp="19bbczm54ml9r" />
        <span data-id="element-32" data-mp="15arg8jogtjo5">{label}</span>
      </a>
      {note && <p className={`mt-4 text-center text-sm leading-relaxed ${tone === 'dark' ? 'text-sky-light' : 'text-muted'}`} data-id="element-33" data-mp="35x5y7jbaqy4l">
          {note}
        </p>}
    </div>;
}